import { useToastStore } from '@/shared/lib/toast';

/**
 * 서명 URL 의 파일을 원래 이름으로 내려받는다.
 *
 * `<a download>` 로는 안 되고 blob 을 거쳐야 한다 — 서명 URL 은 스토리지 오리진이라
 * 크로스 오리진이고, 그 경우 브라우저가 `download` 속성의 파일 이름을 무시한다.
 *
 * 저장 형식은 받은 Content-Type 이 아니라 내려받기 전용으로 고정한다. blob URL 은 앱 오리진에
 * 붙으므로, 받은 형식을 그대로 두면 외부 주소가 들어오는 자리(채팅 첨부)에서 남의 html·svg 가
 * 앱 오리진의 파일이 된다 — 서명 URL 의 다운로드 강제(PR #948)가 막은 것을 여기서 되살리지 않는다.
 */
export function downloadFile(url: string, fileName: string): void {
  void fetch(url)
    .then((res) => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.blob();
    })
    .then((blob) => {
      const href = URL.createObjectURL(new Blob([blob], { type: 'application/octet-stream' }));
      const a = document.createElement('a');
      a.href = href;
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(href);
    })
    .catch(() => {
      useToastStore.getState().addToast({
        title: '파일 다운로드에 실패했습니다',
        type: 'error',
      });
    });
}
